module.exports = __webpack_public_path__ + "static/media/Arrow.9f4c7ff2.png";